import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { SuccessDialog, ErrorDialog } from '../../../components';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Box } from '@material-ui/core';
import { sendCommentToDB } from '../../../logic';

export default function Comment(props) {
  const { open, handleClose, fullName, userID: commentObjectID } = props;
  const [isSuccessDialog, setSuccessDialog] = useState(false);
  const [isErrorDialog, setErrorDialog] = useState(false);
  const [comment, setComment] = useState(null);
  const email = useSelector((state) => state.global?.email);

  const sendComment = async () => {
    try {
      await sendCommentToDB(commentObjectID, email, comment);
      await handleClose(false);
      return setSuccessDialog(true);
    } catch (error) {
      await handleClose(false);
      return setErrorDialog(true);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Добавление комментария</DialogTitle>
        <DialogContent>
          <DialogContentText>
            В данном окне Вы можете оставить отзыв о Вашем опыте общения с
            волонтёром:
            <b>{' ' + fullName}</b>. Данная информация может быть полезной для
            членов Совета Духовного Центра при принятии решения о взятии данного
            волонтёра в свой Отдел.
          </DialogContentText>
          <DialogContentText>
            Комментарий может содержать следующую информацию:
            <br />
            1) когда Вы общались с данным волонтёром;
            <br />
            2) какую роль в своём/другом Отделе ему предлагали;
            <br />
            3) как он отреагировал на Ваше предложение;
            <br />
            4) если отреагировал положительно, то как он относится к работе,
            ответственнен или нет.
          </DialogContentText>
          <Box mt={3}>
            <TextField
              label="Поле для комментария"
              multiline
              variant="outlined"
              fullWidth
              rows={5}
              value={comment}
              onChange={(event) => setComment(event.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Отменить
          </Button>
          <Button onClick={() => sendComment()} color="primary">
            Комментировать
          </Button>
        </DialogActions>
      </Dialog>

      <SuccessDialog
        isSuccessDialog={isSuccessDialog}
        setSuccessDialog={setSuccessDialog}
        updatePage
        description={
          <>
            Вы успешно добавили комментарий о следующем волонтёре:
            <b>{' ' + props.fullName}</b>.
          </>
        }
      />

      <ErrorDialog
        isErrorDialog={isErrorDialog}
        setErrorDialog={setErrorDialog}
      />
    </>
  );
}
